import React from 'react';
import { isReskin } from '../../../config/siteVariant';
import HeaderLegacy from './HeaderLegacy';
import HeaderReskin from './HeaderReskin';

/**
 * Header variant selector. Renders the re-skin header/nav only on a build
 * compiled with REACT_APP_SITE_VARIANT=reskin; otherwise the legacy
 * production header with the original nav. See src/config/siteVariant.js.
 */
const Header = (props) =>
  isReskin ? <HeaderReskin {...props} /> : <HeaderLegacy {...props} />;

export default Header;
